<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
        <!-- <a v-if="item.meta.parent">{{ item.meta.parent.title }}</a>
       <a v-else>{{ item.meta.title }}</a> -->
        <span v-if="index==levelList.length-1" class="no-redirect">
          {{item.meta.parent && item.meta.parent.mosttitle ? item.meta.parent.mosttitle + ' / ' + item.meta.parent.title  + ' / ' + item.meta.title :
          item.meta.parent && !item.meta.parent.mosttitle ? item.meta.parent.title  + ' / ' + item.meta.title : item.meta.title}}
          </span>
        <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import pathToRegexp from 'path-to-regexp'

export default {
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route(route) {
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb() {
      // only show routes with meta.title
      let matched = this.$route.matched.filter(item => item.meta)
      const first = matched[0]
      if (!this.isDashboard(first)) {
        switch(first.name){
          case "Index":
          matched = [{ path: '/', meta: { title: '首页' }}].concat(matched)
         
        }
      }

      this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
    },
    isDashboard(route) {
      const name = route && route.name
      if (!name) {
      
        return false
      }
      return name.trim().toLocaleLowerCase() === '首页'.toLocaleLowerCase()
    },
    // pathCompile(path) {
    //   // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
    //   const { params } = this.$route
    //   console.log(pathToRegexp('/home'))
    //   // var toPath = 
    //   return pathToRegexp('/home')
    // },
    handleLink(item) {
      const { redirect, path } = item
      if(this.$route.name != '/'){
        if(!path){
          this.$router.push(redirect)
        }else{
        this.$router.push(path)
        } 
      }
    }
  }
}
</script>

<style  scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;
  cursor: pointer;
}
  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
</style>
